import { defineComponent as _defineComponent } from 'vue';
import { faArrowUp, faCaretDown, faEdit, faStethoscope, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        prefix: null,
        name: null,
        routeEdit: null,
        routeUpgrade: null,
        isUpgradable: { type: Boolean }
    },
    emits: ["remove", "test"],
    setup(__props, { emit }) {
        const router = useRouter();
        return { __sfc: true, router, emit, faArrowUp, faCaretDown, faEdit, faStethoscope, faTrash, FontAwesomeIcon };
    }
});
